// extracted by mini-css-extract-plugin
export default {"removeImage":"VideoPlayer_removeImage__cEZBa","videoCover":"VideoPlayer_videoCover__h-55t","overlay":"VideoPlayer_overlay__2bgV7","playButton":"VideoPlayer_playButton__VSFw3"};